// extracted by mini-css-extract-plugin
export default {"timeUnit":"kw2zDPT_341TsHfq0pMG","number":"P3p3R7e8cFfOi4D9NhSU","label":"oE8Ln7kBfNXNWVHK6iIQ"};